module.exports = __webpack_public_path__ + "media/images/individual-benefit-5-07cdcdd9f86d7df885a5cd4f4986a989.svg";